import { Spin } from "antd";
import { useOauthSession } from "api/oauth/useOauthSession";
import ErrorPage from "components/ui/ErrorPage";
import { RoleTypes } from "enum/role-type-enum";
import React from "react";
import { /*Navigate,*/ useLocation, useNavigate } from "react-router-dom";
import { storage } from "utils/storage";

// type QueryValue = RoleTypes.ENUMERATOR | RoleTypes.RECRUITER | null;

const OAuth2RedirectHandler = () => {
  const user = storage.getUserFromStorage();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryValue = queryParams.get("roleType");
  const medium = queryParams.get("oauthType");

  const oauthSessionMutation = useOauthSession({ roleType: queryValue, medium: medium });

  const navigate = useNavigate();

  React.useEffect(() => {
    oauthSessionMutation.mutate();
  }, [oauthSessionMutation]);

  if (oauthSessionMutation.error) {
    <ErrorPage error={oauthSessionMutation.error} />;
  }

  if (oauthSessionMutation.isSuccess) {
    setTimeout(() => {
      user?.role === RoleTypes.ENUMERATOR
        ? navigate("/enumerator/home")
        : navigate("/recruiter/home");
    }, 1000);
  }
  return (
    <div
      style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Spin />
    </div>
  );
};

export default OAuth2RedirectHandler;
